var base = require('settings/invoices/invoice-list');

Vue.component('spark-invoice-list', {
    mixins: [base],
    data (){
        return {
            headers: [{
                text: 'Date', value: 'created_at', align: 'left'
            },{
                text: 'Total', value: 'total', align: 'left'
            },{
                value: 'view', sortable: false
            }]
        };
    }
});
